import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/700.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/main.css";

const revealEmailAddress = (element: Element) => {
    const encodedEmailAddress = element.getAttribute("data-eea");

    if (!encodedEmailAddress) {
        return;
    }

    const emailAddress = atob(encodedEmailAddress.replace(/-/g, "+").replace(/_/g, "/"));
    element.setAttribute("href", `mailto:${emailAddress}`);
};

for (const emailLink of document.querySelectorAll("a[data-eea]")) {
    emailLink.addEventListener("mouseover", () => revealEmailAddress(emailLink));
    emailLink.addEventListener("focus", () => revealEmailAddress(emailLink));
}

document.querySelector(".navbar-toggler")?.addEventListener("click", () => {
    document.body.classList.add("drawer-open");
});

document.querySelector(".navbar-toggler + div")?.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
        document.body.classList.remove("drawer-open");
    }
});

for (const dropdownButton of document.querySelectorAll(".dropdown > button")) {
    let isVisible = false;

    dropdownButton.addEventListener("click", () => {
        if (!isVisible) {
            dropdownButton.parentElement?.classList.add("dropdown-open");

            const closeDropdown = () => {
                dropdownButton.parentElement?.classList.remove("dropdown-open");
                window.removeEventListener("click", closeDropdown);
                isVisible = false;
            };

            window.requestAnimationFrame(() => {
                window.addEventListener("click", closeDropdown);
                isVisible = true;
            });
        }
    });
}
